import {
    Typography,
    Box,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Stack,
} from "@mui/material";
import React from "react";
import { formattedDateWithoutBg } from "../../utils/constantFunctions";

const IpdChargesPrint = React.forwardRef((props, ref) => {

    return (
        <Box
            ref={ref}
            sx={{
                padding: "20px",
                maxWidth: "800px",
                margin: "0 auto",
                display: "none",
                "@media print": {
                    display: props && "block",
                },
            }}
        >

            <Typography
                variant="h4"
                align="center"
                gutterBottom
                fontFamily={"Outfit"}
                marginTop={"-5px"}
            >
                {/* Punjab Rheumatology & Immunology Centre */}
                {props?.props?.organization?.name || ""}
            </Typography>
            <Typography align="center" variant="subtitle1">
                <span style={{ display: "block", marginTop: "-5px", fontSize: "14px" }}>
                    {" "}
                    {/* B-35-922/2/1, Ferozpur Road Near MBD Mall */}
                    {props?.props?.organization?.address || ""}
                </span>
                <span style={{ display: "block", marginTop: "-5px", fontSize: "14px" }}>
                    {props?.props?.organization?.pincode || ""}
                    {props?.props?.organization?.city || ""}
                </span>

                <span style={{ display: "block", marginTop: "-5px", fontSize: "14px" }}>
                    {/* +91 98787-36644 */}
                    {props?.props?.organization?.contact_number || ""}
                </span>
            </Typography>
            <Typography
                sx={{ textDecoration: "underline", marginTop: "5px" }}
                align="center"
                alignSelf="center"
            >
                Invoice
            </Typography>


            {/* Invoice Information */}
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "10px",
                    border: "0.5px solid",
                    borderColor: "lightgray",
                    p: 1,
                    pl: 2,
                    pr: 2,
                }}
            >
                <Box width="40$">
                    <Typography>Receipt ID: {props?.props?.old_uid ? props?.props?.old_uid : props?.props?.uid}</Typography>
                </Box>
                <Box>
                    <Typography>
                        {props?.props?.generated_at || new Date()
                            .toLocaleString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                            })
                            .replace(/\//g, "-")
                            .replace(", ", " ")}
                    </Typography>
                </Box>
            </Box>


            {/* Patient Information */}
            <Box sx={{ marginTop: "10px", p: 2, pt: 1 }}>
                {props?.props && (
                    <>
                        <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                        >
                            {props?.props?.patient_id && (
                                <Typography fontFamily={"Outfit"}>
                                    Patient ID: {props?.props?.patient_uid}
                                </Typography>
                            )}
                            <Typography fontFamily={"Outfit"}>
                                Mobile Number: {props?.props?.mobile}
                            </Typography>
                        </Stack>
                        <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                        >
                            {props?.props?.patient_id && (
                                <Typography fontFamily={"Outfit"}>
                                    Admission No: {props?.props?.ipd_admission?.uid}
                                    {/* Patient ID: {appointmentState?.uid} */}
                                </Typography>
                            )}
                            <Typography fontFamily={"Outfit"}>
                                Admitted on : {formattedDateWithoutBg(props?.props?.ipd_admission?.admitted_at)}
                            </Typography>
                        </Stack></>

                )}
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                >
                    {props?.props && (
                        <Typography fontWeight={"bold"}>
                            {props?.props?.name}
                        </Typography>
                    )}
                    {/* <Typography>Appointment: 19 Sep, 2024 19:40 PM</Typography> */}
                </Stack>
                <Typography>
                    {props?.props?.age && `${props?.props?.age}  | `}
                    {props?.props?.gender &&
                        `${props?.props?.gender} | `}
                    {props?.props?.patient_address &&
                        `${props?.props?.patient_address}`}
                </Typography>
            </Box>

            {/* Charges Table */}
            <Table
                sx={{
                    marginTop: "10px",
                    width: "100%",
                    border: "1px solid",
                    borderColor: "lightgrey",
                    borderCollapse: "collapse",
                }}
            >
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ p: "4px", pb: "0px" }}>
                            <strong>Charges Desc</strong>
                        </TableCell>
                        <TableCell sx={{ p: "4px", pb: "0px" }}>
                            <strong>Amount</strong>
                        </TableCell>
                        <TableCell sx={{ p: "4px", pb: "0px" }}>
                            <strong>Units</strong>
                        </TableCell>
                        <TableCell sx={{ p: "4px", pb: "0px" }}>
                            <strong>Total Amount</strong>
                        </TableCell>
                        <TableCell sx={{ p: "4px", pb: "0px" }}>
                            <strong>Discount</strong>
                        </TableCell>
                        <TableCell sx={{ p: "4px", pb: "0px" }}>
                            <strong>Net</strong>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>

                    {props?.props?.invoice_items &&
                        props?.props.invoice_items.map((el, index) => (
                            <TableRow key={el}>
                                <TableCell sx={{ p: "4px" }}>
                                    {el?.specialist_name
                                        ? `${el?.specialist_name} [${el?.specialist_type}]`
                                        : el?.name}
                                </TableCell>
                                <TableCell sx={{ p: "4px" }}>Rs. {el?.cost_per_unit || el?.amount}

                                </TableCell>
                                <TableCell sx={{ p: "4px", marginLeft: '4px' }}>
                                    {el?.quantity}
                                </TableCell>
                                <TableCell sx={{ p: "4px" }}>
                                    Rs. {el?.cost_per_unit * el?.quantity}
                                </TableCell>
                                <TableCell sx={{ p: "4px" }}>
                                    Rs. {el?.discount}
                                </TableCell>
                                <TableCell sx={{ p: "4px" }}>
                                    Rs. {el?.amount}
                                </TableCell>
                            </TableRow>
                        ))}


                    {props?.props && (
                        <TableRow>
                            <TableCell sx={{ p: "4px" }}>
                                <strong>Net Payable Amount</strong>
                            </TableCell>
                            <TableCell sx={{ p: "4px" }}>
                                {/* Rs. {props?.props?.total} */}
                            </TableCell>
                            <TableCell sx={{ p: "4px" }}>
                                {/* Rs. {props?.props?.total} */}
                            </TableCell>
                            <TableCell sx={{ p: "4px" }}>
                                Rs. {props?.props?.total}
                            </TableCell>
                            <TableCell sx={{ p: "4px" }}>
                                Rs. {props?.props?.discount || 0}
                            </TableCell>
                            <TableCell sx={{ p: "4px" }}>
                                <strong>
                                    Rs. {Math.abs(props?.props?.grand_total || 0)} /-
                                </strong>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>

            <Box mt={4}>
                <Typography sx={{ fontSize: 20 }}>Signature</Typography>
                <Box mt={2} sx={{ display: "flex", justifyContent: 'space-between', width: '100%' }}>
                    <Typography sx={{ fontSize: 16, fontWeight: 400 }}>For {props?.props?.organization?.name}</Typography>
                    <Typography sx={{ fontSize: 18 }}>Authorized Signature</Typography>
                </Box>
            </Box>

        </Box>
    );
});

export default IpdChargesPrint;
